import request from '@/utils/request'

//PDA-查看详情
export function getDetailPdaTokenCardDetailShow(query) {
  return request({
    url: '/tokenCard/pdaTokenCardDetailShow',
    method: 'get',
    params: query
  })
}
//列表
export function operationalProcessPage(params) {
  return request({
    url: '/operationalProcess/page',
    method: 'get',
    params
  })
}